import { compose } from 'recompose';

import Label from './label';

const enhance = compose();
export default enhance(Label);
